import DesktopRouter from './DesktopRouter'
import Popups from 'layouts/Popups'
import './style.scss'

const Desktop = () => {
  return (
    <>
      <DesktopRouter />
      <Popups />
    </>
  )
}

export default Desktop